// expiring stars
export const FETCH_EXPIRATIONS = 'FETCH_EXPIRATIONS';
export const FETCH_EXPIRATIONS_SUCCESS = 'FETCH_EXPIRATIONS_SUCCESS';
export const FETCH_EXPIRATIONS_ERROR = 'FETCH_EXPIRATIONS_ERROR';
